import "core-js/modules/es6.object.freeze";
export default Object.freeze({
  BACKSPACE: 'Backspace',
  TAB: 'Tab',
  ENTER: 'Enter',
  ESC: 'Escape',
  LEFT: 'ArrowLeft',
  UP: 'ArrowUp',
  RIGHT: 'ArrowRight',
  DOWN: 'ArrowDown',
  COMMA: 'Comma',
  ONE: 'Digit1',
  TWO: 'Digit2',
  THREE: 'Digit3',
  FOUR: 'Digit4',
  FIVE: 'Digit5',
  SIX: 'Digit6',
  SEVEN: 'Digit7',
  EIGHT: 'Digit8',
  NINE: 'Digit9',
  ZERO: 'Digit0',
  NUM_PAD_ZERO: 'Numpad0',
  NUM_PAD_ONE: 'Numpad1',
  NUM_PAD_TWO: 'Numpad2',
  NUM_PAD_THREE: 'Numpad3',
  NUM_PAD_FOUR: 'Numpad4',
  NUM_PAD_FIVE: 'Numpad5',
  NUM_PAD_SIX: 'Numpad6',
  NUM_PAD_SEVEN: 'Numpad7',
  NUM_PAD_EIGHT: 'Numpad8',
  NUM_PAD_NINE: 'Numpad9',
  A: 'KeyA',
  P: 'KeyP'
});